/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { PayloadAction } from '@reduxjs/toolkit';
import {
	getMonthlySalesInfoRequest,
	getMonthlySalesInfoSuccess,
	getSalesInfoRequest,
	getSalesInfoSuccess,
	getTotalTaxesRequest,
	getTotalTaxesSuccess,
} from './reducer';
import {
	TMonthlySalesInfoRequest,
	TMonthlySalesInfoResponsePayload,
	TSalesInfoRequest,
	TSalesInfoResponsePayload,
	TTotalTaxesRequest,
	TTotalTaxesResponsePayload,
} from './types';

function* getTotalTaxesWorker(action: PayloadAction<TTotalTaxesRequest>) {
	const { payload } = action;
	try {
		const response: TTotalTaxesResponsePayload = yield call(api.dashboard.getTotalTaxes, payload);
		yield put(getTotalTaxesSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getSalesInfoWorker(action: PayloadAction<TSalesInfoRequest>) {
	const { payload } = action;
	try {
		const response: TSalesInfoResponsePayload = yield call(api.dashboard.getSalesInfo, payload);
		yield put(getSalesInfoSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getMonthlySalesInfoWorker(action: PayloadAction<TMonthlySalesInfoRequest>) {
	const { payload } = action;
	try {
		const response: TMonthlySalesInfoResponsePayload = yield call(
			api.dashboard.getMonthlySalesInfo,
			payload,
		);
		yield put(getMonthlySalesInfoSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

export function* dashboardSaga() {
	yield takeEvery(getTotalTaxesRequest.type, getTotalTaxesWorker);
	yield takeEvery(getSalesInfoRequest.type, getSalesInfoWorker);
	yield takeEvery(getMonthlySalesInfoRequest.type, getMonthlySalesInfoWorker);
}
